"use client";

import { Button, Tag } from "antd";
import { IconChevronRight, IconTicket } from "@/lib/icons";
import { getSeasonPassOfferStyle } from "./ticketTheme";

/**
 * Shared season-pass offer used on Venue and Date & Time steps.
 * Uses the blue ticket theme gradient only.
 */
export default function SeasonPassOfferCard({
  title = "Season Pass Available",
  description = "Multi-day / multi-city passes that include your selected event. Optional — you can still book individual tickets.",
  onViewPasses,
  onContinueIndividual,
  labelsOnly = false,
  closed = false,
}) {
  const offer = getSeasonPassOfferStyle();

  return (
    <div
      className="rounded-2xl relative overflow-hidden"
      style={{
        background: offer.gradient,
        border: `1.5px solid ${offer.border}`,
        boxShadow: "0 8px 24px rgba(121, 201, 255, 0.35)",
        opacity: closed ? 0.7 : 1,
      }}
    >
      <div className="relative p-4 sm:p-5">
        <div
          className={`flex items-center gap-3 ${labelsOnly ? "" : "mb-3"}`}
        >
          <span
            className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 shadow-sm"
            style={{
              background: offer.iconBg,
              border: `2px solid ${offer.accent.bg}`,
              color: offer.text,
            }}
          >
            <IconTicket size={18} stroke={2} />
          </span>

          <div className="min-w-0 flex-1">
            <p
              className="m-0 text-sm sm:text-[15px] font-bold leading-snug"
              style={{ color: offer.text }}
            >
              {title}
            </p>
            {!labelsOnly && description ? (
              <p
                className="m-0 mt-1 text-xs leading-relaxed"
                style={{ color: "rgba(5, 28, 91, 0.72)" }}
              >
                {description}
              </p>
            ) : null}
          </div>

          {true ? (
            closed ? (
              <Tag
                color="blue"
                className="shrink-0 !m-0 !px-3 !py-2"
                style={{
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "#91caff",
                }}
              >
                Sales Closed
              </Tag>
            ) : (
              <span
                className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center shadow-sm"
                style={{
                  background: offer.text,
                  color: "#fff",
                }}
                aria-hidden
              >
                <IconChevronRight size={16} stroke={2.5} />
              </span>
            )
          ) : null}
        </div>

        {!labelsOnly && (
          <div className="flex flex-col sm:flex-row gap-2.5">
            {onViewPasses ? (
              <Button
                type="primary"
                size="large"
                className="font-semibold!"
                onClick={onViewPasses}
                style={{
                  background: offer.text,
                  borderColor: offer.text,
                }}
              >
                View Season Passes
              </Button>
            ) : null}
            {onContinueIndividual ? (
              <Button
                size="large"
                className="font-medium!"
                onClick={onContinueIndividual}
                style={{
                  background: "#fff",
                  borderColor: offer.accent.bg,
                  color: offer.text,
                }}
              >
                Continue with Individual Tickets
              </Button>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
